import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';

import { navDropdownOpenClose } from '../../animations/nav-dropdown-open-close.animation';
import { LoggerService } from '../../services/logger.service';


export class NavUserItemComponent implements OnInit {

   employee : any;
  public isShown = false;

  
  public onLogout : EventEmitter<void> = new EventEmitter<void>();

  constructor( private loggerService: LoggerService) { }

  ngOnInit() {
    this.loggerService.log('... initializing NavUserItemComponent from core module.');
  }

  public clickLogout() : any {
    this.onLogout.emit();
  }

  public onHidden(): void {
    this.loggerService.log("onHidden()");
    this.isShown = false;
  }
  public onShown(): void {
    this.loggerService.log("onShown()");
    this.isShown = true;
  }
  public isOpenChange(): void {
    console.log('Dropdown state is changed');
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-layout-navbar-user]',
  template: `
  <span dropdown class="dropdown" (onShown)="onShown()" (onHidden)="onHidden()" (isOpenChange)="isOpenChange()">
    <a dropdownToggle class="dropdown-toggle" >
    <div>
      <img alt="image" class="img-circle" src="http://10.129.100.30/rest/user/{{employee.id}}/photo?square=true" width="60" height="60">
    </div>
    <span class="block m-t-xs ng-binding">
      <strong class="font-bold ng-binding">{{employee.name}}</strong><br>{{employee.surname}}
    </span>
    <small  ><span class="text-muted text-xs block">{{ 'leaf.common.options' | translate }}&nbsp;&nbsp;<span class="fa fa-caret-down"></span></span></small>
    </a>
    <ul *dropdownMenu class="dropdown-menu" [@navDropdownOpenClose]="isShown">
      <li><a>Mi perfil</a></li>
      <li class="divider"></li>
      <li (click)="clickLogout()"><a><i class="fa fa-sign-out"></i>&nbsp; {{ 'leaf.common.signout' | translate }}</a></li>
    </ul>
  </span>
  `,
  animations: [navDropdownOpenClose]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LoggerService, decorators: [{ type: Inject, args: ['LoggerService', ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'employee': [{ type: Input, args: ['leaf-layout-navbar-user', ] },],
'onLogout': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
